import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent } from 'react';
import { useState } from 'react';

import BPImage from '../../ui/v2/image';
import Modal from '../../ui/modal';

import classes from './about-us.module.css';
import { useAppContext } from '../../providers/app-context';

const AboutUs: FunctionComponent = () => {
  const { t } = useTranslation();
  const { businessValues } = useAppContext();
  const [isOpenKey, setIsOpenKey] = useState('');
  return (
    <section
      className={cx(
        'container',
        'grid',
        'lg:grid-cols-2',
        'lg:gap-24',
        'mx-auto',
        'p-4'
      )}
    >
      <div className="">
        {/* TODO: DUPLICATED H1 */}
        <h1 className="font-bold text-2xl pb-3">{t('about:about-us.title')}</h1>
        <Trans
          i18nKey="about:about-us.text"
          components={{ p: <p className="py-3 text-justify" /> }}
        />
      </div>
      <div className="relative pt-9 lg:pt-12 xl:pt-0">
        <div className="flex justify-center lg:justify-start w-5/6">
          <BPImage
            src={`${process.env.PUBLIC_PREFIX}/img/about/about-us.jpg?v=2`}
            width={440}
            height={480}
            alt={t('about:about-us.imgAlt')}
            quality={100}
          />
        </div>
        <div className="absolute right-0 top-0 flex flex-col w-2/3 h-full pb-20 sm:pb-24 lg:pb-28">
          <div
            tabIndex={0}
            role="button"
            aria-pressed={isOpenKey === 'vision' ? 'true' : 'false'}
            className={cx(
              classes.animatedBorderBottom,
              'ml-20',
              'flex-1',
              'flex',
              'items-end',
              'justify-end'
            )}
            onClick={() => {
              setIsOpenKey('vision');
            }}
          >
            <h2 className={cx('text-right', 'text-sm', 'font-extrabold')}>
              {t('about:about-us.vision')}
            </h2>
          </div>
          <div
            tabIndex={0}
            role="button"
            aria-pressed={isOpenKey === 'values' ? 'true' : 'false'}
            className={cx(
              classes.animatedBorderBottom,
              'flex-1',
              'flex',
              'items-end',
              'justify-end'
            )}
            onClick={() => {
              setIsOpenKey('values');
            }}
          >
            <h2 className={cx('text-right', 'text-sm', 'font-extrabold')}>
              {t('about:about-us.values')}
            </h2>
          </div>
          <div
            tabIndex={0}
            role="button"
            aria-pressed={isOpenKey === 'mission' ? 'true' : 'false'}
            className={cx(
              classes.animatedBorderBottom,
              'ml-20',
              'flex-1',
              'flex',
              'items-end',
              'justify-end'
            )}
            onClick={() => {
              setIsOpenKey('mission');
            }}
          >
            <h2 className={cx('text-right', 'text-sm', 'font-extrabold')}>
              {t('about:about-us.mission')}
            </h2>
          </div>
          <div
            tabIndex={0}
            role="button"
            aria-pressed={isOpenKey === 'pillars' ? 'true' : 'false'}
            className={cx(
              classes.animatedBorderBottom,
              'flex-1',
              'flex',
              'items-end',
              'justify-end'
            )}
            onClick={() => {
              setIsOpenKey('pillars');
            }}
          >
            <h2 className={cx('text-right', 'text-sm', 'font-extrabold')}>
              {t('about:about-us.pillars')}
            </h2>
          </div>
        </div>
      </div>

      {!!isOpenKey && (
        <Modal
          title={isOpenKey && t(`about:about-us.${isOpenKey}`)}
          titleVariant="left"
          onRequestClose={() => setIsOpenKey('')}
          isOpen={!!isOpenKey}
          variant="1/2"
        >
          <div className="pb-4">
            <Trans
              i18nKey={`about:about-us.${isOpenKey}Desc`}
              components={{
                p: <p className="py-3" />,
                b: <b className="font-bold" />,
              }
              }
              values={{ totalStockAvailable: businessValues.totalStockAvailable.defaultValue }}
            />
          </div>
        </Modal>
      )}
    </section>
  );
};

export default AboutUs;
